import { Box, CircularProgress } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { isLoaded } from "react-redux-firebase";
import { RootState } from "redux/model";

const AuthIsReady = ({ children }) => {
    const auth = useSelector((state: RootState) => state.firebase.auth);
    if (!isLoaded(auth))
        return (
            <Box
                width="100vw"
                height="100vh"
                bgcolor="white"
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <CircularProgress size={48} />
            </Box>
        );
    return children;
};

export default AuthIsReady;
export { AuthIsReady };
